import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  returnMethodFromModel,
  validateReturnMethodCondition,
  type ReturnMethodState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ReturnOptionMethod } from "@redotech/redo-return-core-common/return-flow/return-option";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const getLabelForReturnOption = (option: ReturnOptionMethod["type"]) => {
  return option === ReturnOptionMethod.EXCHANGE
    ? t("Exchange")
    : option === ReturnOptionMethod.STORE_CREDIT
      ? t("Store credit")
      : option === ReturnOptionMethod.REPAIR
        ? t("Repair")
        : t("Refund");
};

export const RETURN_METHOD = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ReturnMethodState>>,
): ConditionType<ReturnMethodState, Condition.ReturnMethod> => ({
  name: CONDITION_NAMES[Condition.RETURN_METHOD],
  description(state) {
    if (state.returnMethod === ReturnOptionMethod.EXCHANGE) {
      return state.hasAnyExchangeItem
        ? t("Has any exchange item")
        : t("Customer chooses exchange as compensation");
    }
    return t("Return method = {{method}}", {
      method: getLabelForReturnOption(state.returnMethod),
    });
  },
  Details(props: ConditionTypeDetailsProps<ReturnMethodState>) {
    return React.createElement(Details, props);
  },
  empty: {
    returnMethod: ReturnOptionMethod.EXCHANGE,
    hasAnyExchangeItem: false,
  },
  fromModel(model) {
    return returnMethodFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.RETURN_METHOD,
      returnMethod: state.returnMethod,
      hasAnyExchangeItem: state.hasAnyExchangeItem,
    };
  },
  valid(state) {
    return validateReturnMethodCondition(state).valid;
  },
});
